module.exports = __webpack_public_path__ + "assets/img/certification3.4126a53c.svg";